import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Data, Router } from "@angular/router";
import { WebShopService } from "../services/webShop.service";
import { WebShopMode } from "../services/IWebShopService";

@Injectable({
  providedIn: "root"
})
export class WebshopServiceModeResolver implements Resolve<WebShopMode> {

  constructor(private _webShopService: WebShopService
    , private _router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<WebShopMode> {
    const me = this;
    return new Promise<WebShopMode>((resolve, reject) => {
      // Wait for webshop service to fully load (restore from storage)
      me._webShopService.getFullyLoadedObservable.subscribe(() => {
        if (me._webShopService.getServiceMode() != null) {
          resolve(me._webShopService.getServiceMode());
        } else {
          resolve(null);
          me._router.navigate(["/menuservice"]);
        }
      });
    });
  }
}
